import {HttpErrorResponse} from '@angular/common/http';
import {throwError} from 'rxjs';
import {environment} from '../../environments/environment';
import {formatDate} from '@angular/common';
import {Constants} from './constants';

export class Utilities {
    static log(data: any) {
        if (!environment.production) {
        }
    }

    static getSwalConfirmConfig(title: string, text: string, confirmText: string, cancelText: string) {
        return {
            title,
            text,
            showCancelButton: true,
            confirmButtonText: confirmText,
            cancelButtonText: cancelText,
            cancelButtonClass: 'btn btn-primary-outline',
            confirmButtonClass: 'btn btn-primary',
            buttonsStyling: false
        }
    }

    static handleError(error: HttpErrorResponse) {
        let errorMessage = 'Unknown error!';
        if (error.error instanceof ErrorEvent) {
            // Client-side errors
            errorMessage = `Error: ${error.error.message}`;
        } else {
            // Server-side errors
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        window.alert(errorMessage);
        return throwError(errorMessage);
    }

    static mapToObject(map) {
        return [...map.entries()].reduce((obj, [key, value]) => (obj[key] = value, obj), {});
    }

    static objectToMap<T>(object): Map<string, T> {
        return new Map<string, T>(Object.entries<T>(object));
    }

    static getTranslateUrl() {
        return environment.translateUrl;
    }

    static getServiceUrl() {
        return environment.serviceUrl;
    }

    static getFoodSelectorRedirectUrl() {
        return environment.foodSelectorUrl;
    }

    static getRestaurantAppRedirectUrl() {
        return environment.restaurantAppUrl;
    }

    static getTranslateSaveUrl() {
        return environment.translateSaveUrl;
    }

    static dateToBackendString(date: Date) {
        return formatDate(date, 'yyyy-MM-dd', 'en-US');
    }

    static getDifferenceInDaysBetweenDates(start: Date, end: Date) {
        const diff = Math.abs(start.getTime() - end.getTime());
        return Math.ceil(diff / (1000 * 3600 * 24));
    }

    static onlyTimeToBackendString(date: Date) {
        return formatDate(date, 'HH:mm:ss', 'en-US');
    }

    static dateToBackendDateTimeString(date: Date, replace?: boolean) {
        return formatDate(date, 'yyyy-MM-dd HH:mm:ss', 'en-US').replace(' ', replace ? 'T' : ' ');
    }

    static dateToBackendDateStartOfDayString(date: Date, replace?: boolean) {
        date.setHours(0, 0, 1);
        return formatDate(date, 'yyyy-MM-dd HH:mm:ss', 'en-US').replace(' ', replace ? 'T' : ' ');
    }

    static dateToBackendDateEndOfDayString(date: Date, replace?: boolean) {
        date.setHours(23, 59, 59);
        return formatDate(date, 'yyyy-MM-dd HH:mm:ss', 'en-US').replace(' ', replace ? 'T' : ' ');
    }

    static arraysEqual(a, b) {
        if (a === b) return true;
        if (a == null || b == null) return false;
        if (a.length !== b.length) return false;
        for (let i = 0; i < a.length; ++i) {
            if (a[i] !== b[i]) return false;
        }
        return true;
    }

    static timeToBackendString(id: string) {
        const time = id.split('-');

        return time[0].trim() + ':00';
    }

    static addDays(date, days) {
        const result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    static minusDays(date, days) {
        const result = new Date(date);
        result.setDate(result.getDate() - days);
        return result;
    }

    static addMinutesToDate(date: Date, minutes): Date {
        const timeStamp = date.getTime() + (minutes * 60000);
        return new Date(timeStamp);
    }

    static addHoursToDate(date: Date, hours): Date {
        const timeStamp = date.getTime() + (hours * 1000 * 60 * 60);
        return new Date(timeStamp);
    }

    static isProduction() {
        return environment.production;
    }

    static findMin(array: number[]): number {
        return Math.min(...array)
    }

    static findMax(array: number[]): number {
        return Math.max(...array)
    }

    static sortByCreatedAt() {
        return (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
    }

    static validateEmail(email: string): boolean {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    static createMultiSelectElements(entityList: any[], idField: string, nameField: string): any[] {
        const result = [];
        entityList.forEach(entity => {
            result.push(Utilities.createMultiSelectElement(entity, idField, nameField));
        });
        return result;
    }

    static createMultiSelectElement(entity: any[], idField: string, nameField: string) {
        return {
            id: entity[idField],
            itemName: entity[nameField],
            entity
        };
    }

    static createModalConfig(initialState, cssClass?: string): any {
        return {
            class: (cssClass ? cssClass : 'modal-xl'),
            initialState,
            animated: true,
            backdrop: 'static',
            keyboard: false,
        };
    }

    static dateToPath(date: Date) {
        return formatDate(date, 'yyyy_MM_dd_HH_mm_ss', 'en-US')
    }

    static createHourSet(value, d: Date, startHour: number) {
        const hoursArray = [];
        d.setHours(startHour, 0, 0, 0);
        const date = d.getDate();
        while (date == d.getDate()) {
            hoursArray.push(('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2) + ':00');
            d.setMinutes(d.getMinutes() + value);
        }
        return hoursArray;
    }

    static replaceEmailTemplateThUTextAttribute(templateString) {
        function replaceTranslatePart(match, offset, string) {
            const key = match.match(/\('(.*)'\)/)[1];

            const retString: string = '>' + '{{getTranslationByKey(\'' + key + '\')}}';
            return retString + ' <a class="ml-2" href="javascript:void(0)" title="Edit" (click)="edit(\'' + key + '\')"><i class=" tim-icons icon-pencil"> </i></a>'
        }

        return templateString.replace(/th:u?text="\${translator\.toLocale\('[a-zA-Z\.\d-]+'\)}">/g, replaceTranslatePart);
    }

    static getRandomIntArray(min: number, max: number, length: number, roundTo?: number): number[] {
        let numGen = () => Math.floor((Math.random() * (max - min + 1)) + min);
        if (roundTo != undefined) {
            numGen = () => Math.round(Math.floor((Math.random() * (max - min + 1)) + min) / roundTo) * roundTo;
        }
        return Array.from({length}, numGen);
    }

    static range(start: number, end: number, step: number): number[] {
        if (end === start || step === 0) {
            return [start];
        }
        if (step < 0) {
            step = -step;
        }

        const stepNumOfDecimal = step.toString().split('.')[1]?.length || 0;
        const endNumOfDecimal = end.toString().split('.')[1]?.length || 0;
        const maxNumOfDecimal = Math.max(stepNumOfDecimal, endNumOfDecimal);
        const power = Math.pow(10, maxNumOfDecimal);
        const diff = Math.abs(end - start);
        const count = Math.trunc(diff / step + 1);
        step = end - start > 0 ? step : -step;

        const intStart = Math.trunc(start * power);
        return Array.from(Array(count).keys())
            .map(x => {
                const increment = Math.trunc(x * step * power);
                const value = intStart + increment;
                return Math.trunc(value) / power;
            });
    }

    static uniqs(array: any[]): any[] {
        return [...new Set(array)];
    };

    static getDate(date: any): Date {
        if (typeof date == 'string') {
            return new Date(date);
        }
        return new Date(
            Utilities.getDateTimeFromJacksonJSON(date)
        );
    }

    static getTimeFromJacksonJSON(time: any) :string{
        return String(time.hour).padStart(2,'0')+':'
        + String(time.minute).padStart(2,'0')+':'
        + String(time.second).padStart(2,'0');
    }
    static getDateFromJacksonJSON(date: any) :string{
        console.log(date);
        return date.year+'-'
            + String(date.monthValue).padStart(2,'0')+'-'
            + String(date.dayOfMonth).padStart(2,'0');
    }
    static getDateTimeFromJacksonJSON(dateTime: any) :string{
        return dateTime.year+'-'
            + String(dateTime.monthValue).padStart(2,'0')+'-'
            + String(dateTime.dayOfMonth).padStart(2,'0')+ ' '
            + String(dateTime.hour).padStart(2,'0')+':'
            + String(dateTime.minute).padStart(2,'0')+':'
            + String(dateTime.second).padStart(2,'0')
    }

    static getUniqueId(parts: number): string {
        const stringArr = [];
        for(let i = 0; i< parts; i++){
            // tslint:disable-next-line:no-bitwise
            const S4 = (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
            stringArr.push(S4);
        }
        return stringArr.join('-');
    }
}
